import React from 'react'
import LtsDropdownUnidade from '../../../components/lottus/lts-dropdown-unidade'
import _ from 'lodash'
import utils, { getMessage } from '../../../utils'
import { Card } from 'primereact/card'
import LtsLookupGrupoFinanceiro from '../../../components/lottus/lts-lookup-grupo-financeiro'
import LtsDropdownIdValue from '../../../components/lottus/lts-dropdown-id-value'
import LtsLookupContaCorrente from '../../../components/lottus/lts-lookup-conta-corrente'
import LtsCalendar from '../../../components/lottus/lts-calendar'
import LtsCurrency from '../../../components/lottus/lts-currency'

const filtroCaixa = {
  campo: 'caixa',
  valor: true,
  tipoFiltro: 'IGUAL_A',
}

const filtroEntrada = {
  campo: 'tipo',
  valor: 1, //ENTRADA
  tipoFiltro: 'IGUAL_A',
}

const filtroSaida = {
  campo: 'tipo',
  valor: 2, //SAIDA
  tipoFiltro: 'IGUAL_A',
}

export const TransferenciaEntreContasForm = (props) => {
  const record = props.record
  const messages = props.messages
  const setField = props.setField

  const resolveFiltersLookupGrupoOrigem = (filters) => {
    filters.push(filtroSaida)
    filters.push(filtroCaixa)
  }
  const resolveFiltersLookupGrupoDestino = (filters) => {
    filters.push(filtroEntrada)
    filters.push(filtroCaixa)
  }

  return (
    <div className="p-grid p-fluid">
      <div className="p-col-12">
        <Card>
          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-12 p-md-10 p-lg-8 p-xl-6">
              <LtsDropdownUnidade
                name={'unidadeOrigem'}
                label={getMessage(messages, 'transferenciaentrecontas.label.unidadeorigem')}
                value={record.unidadeOrigem}
                onChange={(e) => props.onChangeUnidade('unidadeOrigem', e)}
                disabled={props.disableUnit}
              />
            </div>
          </div>
          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-6 p-md-4 p-lg-3 p-xl-3">
              <LtsLookupGrupoFinanceiro
                value={_.get(record, 'grupoOrigem.value', null)}
                editHidden={true}
                field={'grupoOrigem'}
                multiple={false}
                onChange={(e) => {
                  const value = { id: _.get(e, 'oid', null), value: _.get(e, 'descricao', null) }
                  setField('grupoOrigem', value)
                }}
                resolveFilters={resolveFiltersLookupGrupoOrigem}
                label={getMessage(messages, 'transferenciaentrecontas.label.grupofinanceiroorigem')}
              />
            </div>
          </div>
          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-6 p-md-4 p-lg-3 p-xl-3">
              <LtsDropdownIdValue
                name={'formaPagamentoOrigem'}
                value={record.formaPagamentoOrigem}
                onChange={(e) => setField('formaPagamentoOrigem', e)}
                label={getMessage(messages, 'transferenciaentrecontas.label.formapagamentoorigem')}
                options={props.formasPagamentoOrigem}
                disabled={!record.unidadeOrigem}
              />
            </div>
          </div>
          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-6 p-md-4 p-lg-3 p-xl-3">
              <LtsLookupContaCorrente
                label={utils.getMessage(messages, 'transferenciaentrecontas.label.contacorrenteorigem')}
                value={_.get(record, 'contaCorrenteOrigem.value', '')}
                oidRecord={_.get(record, 'contaCorrenteOrigem.id', '')}
                history={props.history}
                onChange={(e) => setField('contaCorrenteOrigem', { id: e.oid, value: e.descricao })}
              />
            </div>
          </div>

          {/*  DESTINO  */}

          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-12 p-md-10 p-lg-8 p-xl-6">
              <LtsDropdownUnidade
                name={'unidadeDestino'}
                label={getMessage(messages, 'transferenciaentrecontas.label.unidadedestino')}
                value={record.unidadeDestino}
                onChange={(e) => props.onChangeUnidade('unidadeDestino', e)}
                disabled={props.disableUnit}
              />
            </div>
          </div>
          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-6 p-md-4 p-lg-3 p-xl-3">
              <LtsLookupGrupoFinanceiro
                value={_.get(record, 'grupoDestino.value', null)}
                editHidden={true}
                field={'grupoDestino'}
                multiple={false}
                onChange={(e) => {
                  const value = { id: _.get(e, 'oid', null), value: _.get(e, 'descricao', null) }
                  setField('grupoDestino', value)
                }}
                resolveFilters={resolveFiltersLookupGrupoDestino}
                label={getMessage(messages, 'transferenciaentrecontas.label.grupofinanceirodestino')}
              />
            </div>
          </div>
          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-6 p-md-4 p-lg-3 p-xl-3">
              <LtsDropdownIdValue
                name={'formaPagamentoDestino'}
                value={record.formaPagamentoDestino}
                onChange={(e) => setField('formaPagamentoDestino', e)}
                label={getMessage(messages, 'transferenciaentrecontas.label.formapagamentodestino')}
                options={props.formasPagamentoDestino}
                disabled={!record.unidadeDestino}
              />
            </div>
          </div>
          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-6 p-md-4 p-lg-3 p-xl-3">
              <LtsLookupContaCorrente
                label={utils.getMessage(messages, 'transferenciaentrecontas.label.contacorrentedestino')}
                value={_.get(record, 'contaCorrenteDestino.value', '')}
                oidRecord={_.get(record, 'contaCorrenteDestino.id', '')}
                history={props.history}
                onChange={(e) => setField('contaCorrenteDestino', { id: e.oid, value: e.descricao })}
              />
            </div>
          </div>
          {/* ---- */}
          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-6 p-md-4 p-lg-3 p-xl-3">
              <LtsCalendar
                label={utils.getMessage(messages, 'transferenciaentrecontas.label.datapagamento')}
                value={record.dataPagamento}
                onChange={(e) => props.setField('dataPagamento', e)}
                name="dataPagamento"
              />
            </div>
          </div>
          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-6 p-md-4 p-lg-3 p-xl-3">
              <LtsCurrency
                value={record.valor}
                name={'valor'}
                label={utils.getMessage(messages, 'transferenciaentrecontas.label.valor')}
                onChange={(e) => props.setField('valor', e)}
              />
            </div>
          </div>
        </Card>
      </div>
    </div>
  )
}
